/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WidgetCopyRequest
 */
export interface WidgetCopyRequest {
    /**
     * 
     * @type {string}
     * @memberof WidgetCopyRequest
     */
    dashboardKey: string;
}

/**
 * Check if a given object implements the WidgetCopyRequest interface.
 */
export function instanceOfWidgetCopyRequest(value: object): value is WidgetCopyRequest {
    if (!('dashboardKey' in value) || value['dashboardKey'] === undefined) return false;
    return true;
}

export function WidgetCopyRequestFromJSON(json: any): WidgetCopyRequest {
    return WidgetCopyRequestFromJSONTyped(json, false);
}

export function WidgetCopyRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): WidgetCopyRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'dashboardKey': json['dashboardKey'],
    };
}

export function WidgetCopyRequestToJSON(json: any): WidgetCopyRequest {
    return WidgetCopyRequestToJSONTyped(json, false);
}

export function WidgetCopyRequestToJSONTyped(value?: WidgetCopyRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dashboardKey': value['dashboardKey'],
    };
}

